export default __webpack_public_path__ + "static/media/requ_s.de7aba21.png";